import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material';
import { inputLabelClasses } from '@mui/material/InputLabel';
import { useTranslation } from 'react-i18next';
import NewTextField from '../../../components/form/TextField';

export default function EmailForm(props: any) {
  const { handleSendEmail, email } = props;
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <form
      action="/"
      method="POST"
      onSubmit={handleSendEmail}
      style={{
        maxWidth: '500px',
      }}
    >
      <DialogTitle variant="h4" fontWeight={700} color={theme.palette.text.primary}>
        {t('email.enterEmail')}
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom color={theme.palette.text.body}>
          {t('email.enterEmailCtx')}
        </Typography>
        <NewTextField
          key={email}
          defaultValue={email}
          disabled={email ? true : false }
          autoFocus
          required
          margin="dense"
          id="email"
          label={'Email'}
          type="email"
          fullWidth
          variant="outlined"
          InputLabelProps={{
            style: {
              color: '#a6b1bb',
            },
          }}
          sx={{
            fieldset: {
              borderColor: '#a6b1bb',
              [`&.${inputLabelClasses.shrink}`]: {
                borderColor: '#a6b1bb',
              },
              '&:focus': {
                borderColor: '#a6b1bb',
              },
            },
          }}
        />
        <DialogActions
          sx={{
            paddingRight: 0,
            paddingLeft: 0,
            paddingTop: 2,
          }}
        >
          <Button fullWidth type="submit" variant="contained" onSubmit={handleSendEmail}>
            {t('email.sendCode')}
          </Button>
        </DialogActions>
      </DialogContent>
    </form>
  );
}
